
// Import Vendors

import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import FarloUiNumberInput from './vendors/farlo-ui-numberinput.js';
import FarloUiList from './vendors/farlo-ui-list.js';
import { farloUiRevolverCarousel } from './vendors/farlo-ui-revolver-carousel';
import { farloUiPostCarousel } from './vendors/farlo-ui-post-slider-carousel';
import { farloUiExperienceCarousel } from './vendors/farlo-ui-experience-slider-carousel.js';
import { farloUiTimelineCarousel } from './vendors/farlo-ui-timeline-carousel.js';
import { farloUiGallery } from './vendors/farlo-ui-gallery.js';
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
//import { addLightboxToGallery } from './vendors/farlo-ui-gallery-lightbox.js';

// Import Footer Components
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';
import { elementInView } from './components/footer/elementInView.js';
import { toggleFAQ } from './components/footer/toggleFAQ.js';
import { navicon } from './components/footer/navicon.js';
import { embedOverlay} from './components/footer/embedOverlay.js';
import { mapLoader } from './components/footer/mapLoader.js';
import { careersReadMore } from './components/footer/careersReadMore.js';
import { setTallestTimelineItemHeight } from './components/footer/setTallestTimelineHeight.js';
import { searchActivate } from './components/footer/searchActivate.js';
import { adjustCardHeights } from './components/footer/syncHeights.js';
import { observeDynamicElements } from './components/footer/syncHeights.js';


((document, window, history) => {
	const pushState = history.pushState;


	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		setTimeout(function() {
			document.body.classList.add("loaded");
		},1000);
		
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}
			if (document.querySelector('.farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-crm__toggle')) {
			const buttons = document.querySelectorAll('.farlo-ui-crm__toggle');
			const crmBlocks = document.querySelectorAll('.farlo-ui-crm[farlo-ui="crm"]');

			buttons.forEach(function(button) {
				let closestCrmBlock = null;
				let closestDistance = Infinity;

				crmBlocks.forEach(function(block) {
					const distance = button.getBoundingClientRect().top - block.getBoundingClientRect().top;
					if (distance > 0 && distance < closestDistance) {
						closestDistance = distance;
						closestCrmBlock = block;
					}
				});

				if (closestCrmBlock) {
					const crmId = closestCrmBlock.getAttribute('data-crm-id');
					button.setAttribute('data-crm-button-for', crmId);
				}
			});

			buttons.forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});
		}


		// if(document.querySelector('.is-style-lightbox-gallery')){
    	// 	addLightboxToGallery();
		// }

		if (document.querySelectorAll('.wp-block-embed')) { 
			embedOverlay();
		}

		if(document.querySelectorAll('.post-slider')){
			adjustCardHeights();
			observeDynamicElements();
		}


		if (document.querySelector('.post-slider__search')){
			searchActivate();
		}

		if (document.querySelector('.farlo-ui-map')){
			mapLoader();
		}

		if (document.querySelector('.careers')){
			careersReadMore();
		}


		if (document.querySelector('.rank-math-list-item')){
			document.querySelectorAll(".rank-math-question").forEach((_el) => {
                _el.dataset.toggled = "0";
                _el.addEventListener("click", () => {
                    toggleFAQ(_el);
                })
            });
		}

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}



		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				_sel.farloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
	
		}
		if (document.querySelector('input[type="number"]')){
			document.querySelectorAll('input[type="number"]').forEach((numberInput) => {
				new FarloUiNumberInput(numberInput);
			});
		}


		if (document.querySelector('.gfield_list_icons')){
            document.querySelectorAll('.gfield_list_icons').forEach(function(buttonContainer) {
                new FarloUiList(buttonContainer);
            });
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
	
			});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				farloUiRevolverCarousel(_sel);
			});
		}

		if (document.querySelector('.post-slider')) {
			document.querySelectorAll('[farlo-ui="post-slider"]').forEach((_sel) => {
				farloUiPostCarousel(_sel);
			});
		}

		if (document.querySelector('.post-slider')) {
			document.querySelectorAll('[farlo-ui="slider"]').forEach((_sel) => {
				farloUiExperienceCarousel(_sel);

			});
		}

		if (document.querySelector('.gallery')) {
			document.querySelectorAll('[farlo-ui="gallery"]').forEach((_sel) => {
				farloUiGallery(_sel);
			});
		}
		
		if (document.querySelector('.timeline')) {
			document.querySelectorAll('[farlo-ui="timeline"]').forEach((_sel) => {
				farloUiTimelineCarousel(_sel);
			});
			setTallestTimelineItemHeight()
		}
		
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
})(document, window, history);
